<template>
    <van-popup
            v-model="show"
            position="bottom"
            :overlay-style="{background: 'rgba(0, 0, 0, 0.3)'}">
        <div :class="['comment-textarea',isFromAlbum&&'comment-textarea-album']">
            <div class="input-area">
                <div class="content-container" :style="getContentContainerStyle">
                    <textarea
                        ref='myTextarea'
                        :placeholder="placeholderText"
                        :style="getTextAreaStyle"
                        @input="handleInput"
                        v-model.trim="text"
                        :rows="defaultRows"
                    />
                    <div class="img-area" v-if="selectImgUrl">
                        <img :src="selectImgUrl" class="upload-img"/>
                        <div class="delete-btn" @click="handleDeleteImg"></div>
                    </div>
                </div>
                <!-- 发布 -->
                <div :class="['publish-btn',canPublish && 'active']" @click="clickSubmit">发布</div>
            </div>
            <div class="upload-btn">
                <ImgUpload 
                    :limitType="limitType"
                    :limitSize="limitSize"
                    inputId="fileInput"
                    @inputClick="handleInputClick"
                    @fileTypeError="handleFileTypeError"
                    @fileSizeError="handleFileSizeError"
                    @upload="handleUploadImg"></ImgUpload>
                <label class="picture-logo" for="fileInput"></label>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { MessageBox } from "@/vue_components/follow-btn/MessageBox/src/main.js"
import localStorageUtil from '@/utils/localstorageUtil'
import { publishComment } from '@/js/article-main/request/api'
import Popup from 'vant/lib/popup'
import Field from 'vant/lib/field'
import 'vant/lib/popup/style';
import 'vant/lib/field/style';
import Util from "@/utils/util.js"
import ImgUpload from "common-components/lib/imgUpload/index"
import 'common-components/lib/imgUpload/index.css'
import { uploadImg } from "@/js/request/commentRequest"
import { sendAction } from "@/utils/spmUtil"
import { acodeConfig } from "@/config/spmConfig"

const contentMinHeight = 62; // 输入区域最小高度
const env = Util.getEnvironment()
const loginHost = {
    test: "https://test-m.sohu.com/login?type=1",
    pre: "https://pre-m.sohu.com/login?type=1",
    prod: "https://m.sohu.com/login?type=1",
}
const loginHref = loginHost[env]

export default {
	name: "",
    components: {
         vanPopup: Popup,
         vanField: Field,
         ImgUpload,
    },
	props: {
        from: {
            default: 'normal',
			type: String
        },
        placeholderText: {
			default: '我来说两句...',
			type: String
		},
	},
	computed: {
        // 来自图集页
        isFromAlbum() {
            return this.from == 'album'
        },
		getTextAreaStyle() {
			return  {
				'line-height': this.minHeight + 'px',
			}
		},
		maxHeight() {
			return this.minHeight * this.maxRow
		},
        canPublish() {
            return !!this.text || this.selectImgUrl
        },
        defaultRows() { // fix:android端qq浏览器，点击发布无效
            // android端qq浏览器默认行数为3行，其余为1行
            const ua = window.navigator.userAgent
            const isAndroid = /Android/i.test(ua)
            const isQQ = ua.toLowerCase().indexOf('qqbrowser') >= 0
            return isAndroid && isQQ ? 3 : 1
        },
        getContentContainerStyle(){
            return {
                'min-height': `${contentMinHeight}px`
            };
        },
        articleId(){
            return window.cfgs?.newsId
        },
        accountId(){
            return window.cfgs?.media_id
        }
	},
	data() {
		return {
            minHeight: 20,
            maxLength: 1000,
            isLogin: false,
            maxRow: 4,
			text: '',
            scrollTop: 0,
            originalBodyStyle: '',
            show: true,
            spmCCode: 'comment-reply',
            limitSize: 10, // 默认上传图片大小限制：10MB
            limitType: ['jpg', 'jpeg', 'png', 'webp', 'gif'], // 默认上传图片类型限制
            selectImgUrl: '', // 选择的图片地址
		}
	},
    mounted() {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        console.log(this.scrollTop, 'scroll');
        this.$refs.myTextarea.focus();
        this.getUserInfo()
    },
    destroyed() {
    },
    watch: {
        show(_new,_old) {
            if(!_new) {
                window.sohuSpm.sendAction({
                    acode: '3560',
                    clkParam: `sourceId:mp_${window.cfgs.newsId};`
                });
                this.closeMask()
            }
        }
    },
	methods: {
        handleBlur() {
            window.scrollTo(0, this.scrollTop)
        },
        getUserInfo() {
            const userInfo = window.userInfo
            if(userInfo?.avatar || userInfo?.userId) {
                this.isLogin = true
            }
        },
        clickSubmit() {
            if(!this.canPublish)return
            // 未登录
            if(!this.isLogin) {
                // 缓存未发布的评论
                localStorageUtil.setItem(`${window.cfgs?.newsId}_comment`, {
                    content: this.text,
                    attachmentUrls: this.selectImgUrl,
                })
                const spmCode = window.sohuSpm.getCodes()
                const spm = `${spmCode && spmCode.a}.${spmCode && spmCode.b}.${this.spmCCode}.2.${spmCode && spmCode.e}`
                window.location.href = `${loginHref}&origin=2&r=${encodeURIComponent(window.location.href)}&spm=${spm}`
                return
            }
            const clkParamObj = {
                articleId: this.articleId,
                accountId: this.accountId,
                url: window.location.href
            }
            // 已登录-去发布
            publishComment({
                content: this.text,
                attachmentUrls: this.selectImgUrl,
            }).then((res)=>{
                if(res.code == 200) {
                    this.$emit('addCommentCount')
                    window?.eventBus?.$emit('addFakeComment',res?.data)
                    window.h5_sohu.plugin.api.call('toast',
                        {text:'发布成功',type:1},
                        function(){}
                    )
                    clkParamObj.status ='success'
                    clkParamObj.commentId = res.data?.id
                    clkParamObj.code = res.code
                    clkParamObj.message = res.msg
                }else if(res.code == 417) { // 封禁
                    window?.eventBus?.$emit('showBannedNotice')
                    clkParamObj.status = 'fail'
                    clkParamObj.code = res.code
                    clkParamObj.message = res.msg
                }
                else {
                    window.h5_sohu.plugin.api.call('toast',
                        {text:res.msg,type:2},
                        function(){}
                    )
                    clkParamObj.status = 'fail'
                    clkParamObj.code = res.code
                    clkParamObj.message = res.msg
                }
            }).catch((error)=>{
                window.h5_sohu.plugin.api.call('toast',
                    {text:'发布失败',type:2},
                    function(){}
                )
                clkParamObj.status = 'error'
                clkParamObj.reason = error.message
                clkParamObj.stack = error.stack
            }).finally(()=>{
                const clkParam = Object.keys(clkParamObj).map(key => `${key}:${clkParamObj[key]}`).join(';')
                sendAction({
                    acode: acodeConfig.commentSubmit,
                    clkParam: clkParam
                })
                this.closeMask()
            })
        },
        closeMask() {
            this.$emit('closeMask',false)
            window.scrollTo(0, this.scrollTop)
        },
		handleInput(e) {
			const textarea = e.target
			const value = textarea.value
			// 动态改变textarea的高度，不超过最大高度
			textarea.style.height = 'auto'
            textarea.style.height = (textarea.scrollHeight > this.maxHeight ? this.maxHeight : textarea.scrollHeight) + 'px'
			// 超出最大长度截断
			if(value && value.length > this.maxLength) {
				this.text = value.substring(0,this.maxLength)
                // toast提示
                MessageBox.$toast({ title: `正文字数超限，最多${this.maxLength}字`,top:'65%' },1000)
			}
		},
        handleInputClick(event){
            if(!this.isLogin){
                event.preventDefault()
                event.stopPropagation()
                MessageBox.$toast({
                    title: '需要登录才可上传图片，即将为您跳转登录页',
                    timeout: 1000,
                })
                const spmCode = window.sohuSpm.getCodes()
                const spm = `${spmCode && spmCode.a}.${spmCode && spmCode.b}.${this.spmCCode}.2.${spmCode && spmCode.e}`
                const loginUrl = Util.addQueryArgs(loginHref, {
                    r: encodeURIComponent(window.location.href),
                    spm: spm
                })
                setTimeout(() => {
                    window.location.href = loginUrl
                }, 1000)
                return
            }
            sendAction({
                acode: acodeConfig.clickImgUpload,
                clkParam: `isLogin:${this.isLogin};articleId:${this.articleId};accountId:${this.accountId};url:${window.location.href}`,
            })
        },
        handleFileTypeError(type){
            const supportTypeStr = this.limitType.join('、')
            MessageBox.$toast({
                title: `请上传 ${supportTypeStr}格式的图片`,
            })
            sendAction({
                acode: acodeConfig.imgUpload,
                clkParam: `status:fail;reason:typeError;articleId:${this.articleId};accountId:${this.accountId};url:${window.location.href};type:${type}`
            })
        },
        handleFileSizeError(size){
            MessageBox.$toast({
                title: `请确保提交的图片文件大小不超过${this.limitSize}MB`
            })
            sendAction({
                acode: acodeConfig.imgUpload,
                clkParam: `status:fail;reason:overSize;articleId:${this.articleId};accountId:${this.accountId};url:${window.location.href};size:${size}`
            })
        },
        async handleUploadImg(file){
            const clkParamObj = {
                articleId: this.articleId,
                accountId: this.accountId,
                url: window.location.href
            }
            try {
                const formData = new FormData()
                formData.append("imgFile", file); // 设置 imgFile 字段为文件对象
                const res = await uploadImg(formData)
                if(res?.code == 200 && res?.data){
                    this.selectImgUrl = res.data
                    clkParamObj.status = 'success'
                }else if(res?.code === 400){
                    MessageBox.$toast({
                        title: `请确保提交的图片文件大小不超过${fileSizeLimit}MB`
                    })
                    clkParamObj.status ='fail'
                    clkParamObj.reason = 'overSize'
                    clkParamObj.code = res.code
                }else{
                    MessageBox.$toast({
                        title: '上传图片失败，请稍后重试'
                    })
                    clkParamObj.status ='fail'
                    clkParamObj.reason = res.msg
                    clkParamObj.code = res.code
                }
            } catch (error) {
                console.log('上传图片失败', error)
                MessageBox.$toast({
                    title: '上传图片失败，请稍后重试'
                })
                clkParamObj.status ='fail'
                clkParamObj.reason = error.message
                clkParamObj.stack = error.stack
                console.log('上传图片失败',error);
            } finally {
                const clkParam = Object.keys(clkParamObj).map(key => `${key}:${clkParamObj[key]}`).join(';')
                sendAction({
                    acode: acodeConfig.imgUpload,
                    clkParam: clkParam
                })
            }
        },
        handleDeleteImg(){
            this.selectImgUrl = ''
        }
	}
}
</script>

<style lang="less" scoped>
.comment-textarea {
    width: 100%;
    display: flex;
    background: white;
    padding: 20px 32px; /*px*/
    box-sizing: border-box;
    flex-direction: column;
    .input-area{
        display: flex;
        align-items: flex-end;
        flex-wrap: nowrap;
        margin-top: 20px; /*px*/
    }
    .content-container {
        flex: 1;
        padding: 20px 24px;/*px*/
        box-sizing: border-box;
        border-radius: 8px;/*px*/
        border: 2px solid rgb(245, 246, 247);/*px*/
        background: rgb(245, 246, 247);
        line-height: 0px;
    }
    textarea {
        border: none;
        outline: none;
        resize: none;
        appearance:none;
        padding: 0;
        margin: 0;
        font-size: 28px;/*px*/
        color: rgb(36, 37, 41);
        scrollbar-width: none; /* Firefox 64+ */
        -ms-overflow-style: none; /* IE/Edge */
        background: rgb(245, 246, 247);
        width: 100%;
    }
    textarea::placeholder {
        color: #999999;
        font-size: 28px; /*px*/
    }
    textarea::-webkit-scrollbar {
        display: none;
    }

    .img-area{
        margin-top: 16px; /*px*/
        width: 128px; /*px*/
        height: 128px; /*px*/
        position: relative;
        .upload-img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .delete-btn{
            position: absolute;
            top: 0px;
            right: 0px;
            width: 32px;/*px*/
            height: 32px;/*px*/
            background: url('../../less/images/icon_delete_picture@2x.png') no-repeat center;
            background-size: contain;
        }
    }

    .publish-btn {
        height: 64px; /*px*/
        width: 120px; /*px*/
        margin-left: 24px;/*px*/
        background: #dcdcdc;
        border-radius: 8px;/*px*/
        font-size: 28px;/*px*/
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        box-sizing: border-box;
        font-weight: 700;
    }
    .active {
        background: #ffd100;
        color: #000;

    }
    .upload-btn{
        margin-top: 20px; /*px*/
        width: 100%;
        height: 72px; /*px*/
        padding: 8px 0px 20px 0px; /*px*/
        box-sizing: border-box;
        .picture-logo{
            display: block;
            width: 44px; /*px*/
            height: 44px; /*px*/
            background: url('../../less/images/icon_picture@3x.png') no-repeat center;
            background-size: contain;
        }
    }
}
// 图集页 黑色
.comment-textarea-album {
    box-shadow: inset 0px 1px 0px 0px rgba(255,255,255,0.2);/*px*/
    color: #999;
    background: #010101;
    textarea {
        color: #999999;
        background: transparent;
        border: none !important;
    }
    textarea::placeholder {
        color: #999999;
    }
    .publish-btn {
        background: rgba(255,255,255,0.2);
        color: #999;
    }
    .active {
        background: #ffd100;
        color: #111;

    }
    .content-container{
        background: rgba(255,255,255,0.2);
        border:none !important;
    }
    .picture-logo{
        background: url('../../less/images/icon_picture_white@2x.png') no-repeat center !important;
        background-size: contain !important;
    }
}
</style>
